// 通用的一些名词
export default {
    'common.language.change':'switch language',
    'common.company.name':'DawnTron (Shenzhen) International Logistics Co., Ltd.',
    'common.company.copyright':'Copyright © 2022 DawnTron (Shenzhen) International Logistics Co., Ltd.',
    'common.company.beian.icp':'苏—ICP备',
    'common.company.beian.gwa':'苏公网安备',
    'common.company.address-title':'address：',
    'common.company.address-info':'Dalang Industrial Park, Longhua District, Shenzhen, Guangdong, China',
    'common.navigation.title.home':'Home',
    'common.navigation.title.about':'About Us',
    'common.navigation.title.query':'Schedule Enquire',
    'common.navigation.title.track':'Transpotation Itinerary',
    'common.navigation.title.contact':'Contact Us',
    'common.footer.slogan':'DawnTron (Shenzhen) International Logistics Co., Ltd. has been constantly exceeding customer expectations since its establishment. For decades, the company formed its unique trade & logistic networks & systems. It is committed to providing professional, accurate and efficient trade & logistic services for global customers!',
    'common.footer.map.website-map':'Sitemap',
    'common.footer.map.help-center':'Support',
    'common.footer.map.help-center.question':'FAQ',
    'common.footer.map.help-center.service':'Customer Service',
    'common.footer.map.help-center.message':'Leave your message',
    'common.footer.map.help-center.price':'Price Enquire',
    'common.footer.map.contact-us':'contact us',
    'common.footer.map.contact-us.whatsApps':'WhatsApp: +86 18576744474',
    'common.footer.map.contact-us.skype':'skype: +86 18576744474',
    'common.footer.dialog.title':'Tips',
    'common.footer.dialog.content':'For any question please contact Phone: +86 18688782252, whatsApp,skype +86 18576744474'
}